import React, { useState } from "react";

const TruncatedText = ({ text, maxLength = 100 }) => {
    const [expanded, setExpanded] = useState(false);

    if (!text) return null;

    const shouldTruncate = text.length > maxLength;
    const displayText = expanded || !shouldTruncate ? text : text.slice(0, maxLength) + "...";

    return (
        <span>
            {displayText}
            {shouldTruncate && (
                <span
                    onClick={() => setExpanded(!expanded)}
                    style={{ color: "#0d6efd", cursor: "pointer", marginLeft: "5px" }}
                >
                    {expanded ? "See Less" : "See More"}
                </span>
            )}
        </span>
    );
};

export default TruncatedText
